// <![CDATA[
(function (e, t, n) { var r, i = e.getElementsByTagName(t)[0]; if (e.getElementById(n)) return; r = e.createElement(t); r.id = n; r.src = "//apps.aftership.com/all.js"; i.parentNode.insertBefore(r, i) })(document, "script", "aftership-jssdk")
// ]]> 

document.observe('dom:loaded', function () {
    $('trackbyid').observe('click', function (e) {
        var orderId = '';
        orderId = $('trackorderid').getValue();
        if (orderId == '') {
            alert('Please input a valid order ID');
            return;
        }
        var url = 'http://www.radioddity.com/us/fetchorder/fetchorder/fetch/';
        var params = { orderId: orderId }
        //alert(orderId);
        //alert('click');
        var details = $('order-status');
        new Ajax.Request(url, {
            method: 'post',
            parameters: params,
            onSuccess: function (transport) {
                if (transport.status == 200) {
                    var response = transport.responseText.evalJSON();
                    console.log(response);
                    //alert('200');
                    if (response.success) {
                        // alert('success');
                        var content = '<table><tr><th>Order ID</th><th>Total</th><th>Status</th></tr>';
                        content += '<tr><td>' + response.incrementid + '</td><td>' + response.total + '</td><td>'
                            + response.orderstatus + '</td></tr></table>'
                        // details.update(response.incrementid);
                        //content = 'test';
                        details.update(content);
                    } else {
                        //alert('200 but not success');
                        details.update('<b>' + response.error + '</b>');
                    }
                }
            }
        }
        );

        // details.update(url); 
    });
});
